import React, { useState } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { TextField } from '@getgo/chameleon-web-react-wrapper';
import { Typography, Button, IconButton } from '@getgo/chameleon-web-react-wrapper';
import { AddOutlinedIcon, TrashOutlinedIcon } from '@getgo/chameleon-icons/react';
import mt from 'core/message-translations';
import classes from '../routes/clients/clientedit/components/client-details-tab.scss';

const EditableListTab = ({
  client,
  canWrite,
  items = [],
  onAddItem,
  onDeleteItem,
  translations,
  validationErrors,
  clearScopeError
}) => {
  const intl = useIntl();
  const [newItem, setNewItem] = useState('');

  const handleAddItem = () => {
    if (newItem.trim() && !items.includes(newItem.trim())) {
      onAddItem(newItem.trim());
      setNewItem('');
    }
  };

  const handleDeleteItem = (itemToDelete) => {
    onDeleteItem(itemToDelete);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddItem();
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setNewItem(value);
    
    // Clear errors immediately when user starts typing
    if (clearScopeError && validationErrors) {
      clearScopeError();
    }
  };

  return (
    <React.Fragment>
      <Box className={classes["ownersContainer"]}>
        <Box className={classes["ownersTabSpacing"]}>
          <TextField
            id="newItem"
            name="newItem"
            value={newItem}
            fullwidth
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            label={intl.formatMessage(translations.fieldLabel)}
            placeholder={intl.formatMessage(translations.fieldPlaceholder)}
            disabled={!canWrite}
            error={!!validationErrors}
            helperText={validationErrors && intl.formatMessage(mt[validationErrors])}
          />
          <Button
            variant="secondary"
            onClick={handleAddItem}
            disabled={!canWrite || !newItem.trim() || items.includes(newItem.trim()) || !!validationErrors}
            leadingIcon={<AddOutlinedIcon />}
          >
            {intl.formatMessage(translations.addButtonText)}
          </Button>
        </Box>
        <Box>
          {items && items.length !== 0 && items.map((item, index) => (
            <Box key={`item-${index}`}>
              <Typography variant="body-small">
                {item}
              </Typography>
              <IconButton
                data-testid="deleteUriButton"
                onClick={() => handleDeleteItem(item)}>
                <TrashOutlinedIcon color="#2C72DE" />
              </IconButton>
            </Box>
          ))}
        </Box>
      </Box>
    </React.Fragment>
  );
};

EditableListTab.propTypes = {
  canWrite: PropTypes.bool,
  client: PropTypes.object,
  fieldTranslations: PropTypes.shape({
    fieldLabel: PropTypes.shape({ id: PropTypes.string, defaultMessage: PropTypes.string }),
    fieldPlaceholder: PropTypes.shape({ id: PropTypes.string, defaultMessage: PropTypes.string }),
    addItemAriaLabel: PropTypes.shape({ id: PropTypes.string, defaultMessage: PropTypes.string }),
    removeItemAriaLabel: PropTypes.shape({ id: PropTypes.string, defaultMessage: PropTypes.string }),
  }),
  items: PropTypes.array,
  onAddItem: PropTypes.func,
  onDeleteItem: PropTypes.func,
  translations: PropTypes.shape({
    fieldLabel: PropTypes.shape({ id: PropTypes.string, defaultMessage: PropTypes.string }),
    fieldPlaceholder: PropTypes.shape({ id: PropTypes.string, defaultMessage: PropTypes.string }),
    addButtonText: PropTypes.shape({ id: PropTypes.string, defaultMessage: PropTypes.string }),
  }),
  validationErrors: PropTypes.string,
  clearScopeError: PropTypes.func,
};

export default EditableListTab;